import { message } from '@/utils/js/initVariable';
import { queryLocationByQuestion } from '@/api/Region';
import { fetchEventSourceInit } from '@/api/fetchInit';
import { aiComponentCreate } from '../../../utils';

/**
 * AI 解读请求/SSE/Controller 管理
 * @param {Object} props - 组件 props
 * @param {Object} map - toRaw(homeMap.value)
 * @param {Ref} loadProp - loading 属性名
 */
export function useAiAnalysis(props, map, loadProp) {
  let aiController;

  const aiControllerClose = () => {
    if (aiController) {
      aiController.abort();
      aiController = undefined;
    }
  }

  const aiLayerInit = (btn, layer, data) => {
    const bounds = layer.getBounds(),
      latlng = bounds.getNorthEast();
    const { app, zoomCloseFn, group } = aiComponentCreate(latlng, {
      analysisResult: data,
      workSpaceId: props.workSpace['id'],
    }, {
      layerGroup: props.layerGroup, map,
    });

    props.layerGroup.addLayer(group);

    layer.once({
      remove: () => {
        props.layerGroup.removeLayer(group);
      }
    })
    group.once({
      remove: event => {
        zoomCloseFn();
        app?.unmount();
      }
    })
  }

  const aiDataRequest = (btn) => {
    const geojson = props.layer.toGeoJSON();
    aiController = new AbortController();
    fetchEventSourceInit(queryLocationByQuestion(), {}, geojson, {
      signal: aiController.signal,
      openWhenHidden: true,
      onopen: (response) => {
        btn[loadProp.value] = true;
      },
      onmessage: (event) => {
        if (event.data === '[DONE]') {
          aiControllerClose();
          return;
        }
        try {
          const data = JSON.parse(event.data);
          console.log(data);
          aiLayerInit(btn, props.layer, data);
        } catch (error) {
          console.error('解析消息错误:', error);
        }
      },
      onerror: (err) => {
        message('AI解读错误', 2);
        btn[loadProp.value] = false;
        aiControllerClose();
      }
    })
  }

  return { aiDataRequest, aiControllerClose };
}
